import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";
import { Ref, ref } from "@vue/composition-api";

export const tableConfig: Ref<ITableConfig> = ref({
  columns: [
    {
      name: "",
      key: "",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "3rem",
      spanMax: "3rem",
    },
    {
      name: "Name",
      key: "displayName",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "6rem",
      spanMax: "1fr",
    },
    {
      name: "Email",
      key: "externalId",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "8rem",
      spanMax: "1.5fr",
    },
    {
      name: "Service",
      key: "service",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "6rem",
      spanMax: "1fr",
    },
    /* {
      name: "Last scan",
      key: "lastSyncAt",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "6rem",
      spanMax: "1fr",
    }, */
    {
      name: "Is scanned",
      key: "lastSyncAt",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "6rem",
      spanMax: "1fr",
    },
  ],
});
